import React from "react"

import "./style.scss"

const Homepage = () => {
  return (
    <div className="homepage">
      <div className="homepage-content" />
    </div>
  )
}

export default Homepage
